import { modalSearchExportSuccess } from '../../../core/declare-components';
import { HuitabModal } from '../../components/common/huitab-modal';
import { mesSddEntrepriseService, mesPrmsOrgaService} from '../../services/api';
import { StoreManager } from '../../services/store-manager';
import { TacheManager } from '../../services/tache-manager';
import { TagCommanderManager } from '../../services/tag-commander-manager';

/**
 * Les types d'environnement du portail colloc
 */
const EspaceType = {
  ED: 'ED',
  API: 'API',
};

const isMicroAppRechercheCompteurs = window.location.pathname === '/mes-donnees-energetiques/mes-compteurs';

export default class ModalEtatServices extends HuitabModal {
  /**
   * Initialise une nouvelle instance de type {@type ModalEtatServices}.
   */
  constructor() {
    super('modal-etat-services');
    window.addEventListener('load', () => {
      const modal = document.getElementById('modal-etat-services');
      const erreurTechnique = document.getElementById('erreur-technique');
      const boutonRedirection = document.getElementById('erreur-technique-bouton-redirection');

      if (erreurTechnique && boutonRedirection && modal) {
        this.toastError = document.getElementById('modal-etat-services').querySelector('huitab-toast');
        // Déplacer le bloc erreur technique dans le contenu modal
        const modalBody = modal.querySelector('.lnc-modal-content div[body]');
        if (modalBody) {
          modalBody.appendChild(erreurTechnique);
        }

        // Configurer le bouton de fermeture
        boutonRedirection.setAttribute('label', 'Fermer');
        boutonRedirection.addEventListener('click', () => {
          super.hideOnDismiss();
        });
        this._initModal();
      }
    });
  }

  _initModal() {
    document
      .getElementById('modal-etat-services')
      ?.getElementsByClassName('submit-btn')
      .item(0)
      .addEventListener('click', () => this.requestExportPrmsSdd());
  }

  show(espaces) {
    this.hideContent();
    super.show();
    this.espaces = espaces.espaces;

    if (this.espaces.includes(EspaceType.ED)) {
      this.espace = EspaceType.ED;
    } else if (this.espaces.includes(EspaceType.API)) {
      this.espace = EspaceType.API;
    }

    this.loadSyntheseEtatServices()
      .then(() => this.showSuccessPrmsSynthese())
      .catch(() => {
        if (isMicroAppRechercheCompteurs) {
          TagCommanderManager.tagPage({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'liste_prm',
            page: 'popin_synthese_erreur',
          });
        } else {
          TagCommanderManager.tagPage({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'cockpit_services_mesures',
            page: 'popin_synthese_erreur',
          });
        }
        this.showError();
      });
  }

  /**
   * Lance les appels de manière asyncrone et affiche les donnnées de la synthèse états de services
   */
  async loadSyntheseEtatServices() {
    const syntheseSddDto = await mesSddEntrepriseService.getSynteseEtatServices(
      StoreManager.cnAlex,
      StoreManager.selectedSiren,
      this.espace,
    );

    this.updateSyntheseSddView(syntheseSddDto);

    const prmTotal = await mesPrmsOrgaService.postTotalPrmsEtatMesServices(
      StoreManager.cnAlex,
      StoreManager.selectedSiren,
    );
    this.updateElementText('number-prm-total', prmTotal.response.nombrePrmTotal);

    const prmCommunicants = await mesPrmsOrgaService.postTotalPrmsCommunicantsEtatMesServices(
      StoreManager.cnAlex,
      StoreManager.selectedSiren,
    );
    this.updateElementText('number-communicants-total', prmCommunicants.response.nombrePrmTotal);
  }

  updateSyntheseSddView(syntheseSddDto) {
    this.updateElementText('number-ems-and-or-api-total', syntheseSddDto.nbServicesActifs);
    this.updateElementText('number-cdc-activate-total', syntheseSddDto.nbServicesCdcActifs);
    this.updateElementText('number-cdc-prolonger-total', syntheseSddDto.nbServicesCdcProlongeable);

    let title = '';
    const hasAPI = this.espaces.includes(EspaceType.API);
    const hasED = this.espaces.includes(EspaceType.ED);

    if (hasAPI && hasED) {
      title = "Dont l'EMS et API sont activés";
    } else if (hasED) {
      title = "Dont l'EMS est activé";
    } else if (hasAPI) {
      title = "Dont l'API est activée";
    }

    this.updateElementText('title-ems-and-or-api-total', title);
  }

  updateElementText(elementId, text) {
    const el = document.getElementById(elementId);
    if (el) el.innerText = text.toLocaleString('fr-FR');
  }

  /**
   * Demande d'export de l'état des services
   */
  requestExportPrmsSdd() {
    document
      .getElementById('modal-etat-services')
      ?.getElementsByClassName('submit-btn')
      .item(0)
      .setAttribute('loading', true);
    mesSddEntrepriseService
      .exportPrmSdd(StoreManager.cnAlex, StoreManager.selectedSiren)
      .then(() => {
        this.hideSuccess();
        modalSearchExportSuccess.show();
        TacheManager._startInterval();
      })
      .catch(() => {
        this.toastError.setAttribute('style', 'display: flex;');
        this.toastError.setToast(
          'Echec du téléchargement, veuillez réessayer plus tard.',
          'true',
          '0',
          'M',
          'error_outline',
          'blanc',
          'rouge-500',
          'Error',
        );
        this.toastError
          .getElementsByTagName('button')
          .item(1)
          .addEventListener('click', (e) => {
            this.toastError.setAttribute('style', 'display: none;');
          });
        if (isMicroAppRechercheCompteurs) {
          TagCommanderManager.tagPage({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'liste_prm',
            page: 'popin_synthese_erreur_telechargement',
          });
        } else {
          TagCommanderManager.tagPage({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'cockpit_services_mesures',
            page: 'popin_synthese_erreur_telechargement',
          });
        }
        this.toastError.show();
      })
      .finally(() => {
        document
          .getElementById('modal-etat-services')
          ?.getElementsByClassName('submit-btn')
          .item(0)
          .removeAttribute('loading');
        if (isMicroAppRechercheCompteurs) {
          TagCommanderManager.tagClick({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'liste_prm',
            page: 'telecharger_letat_de_mes_services',
            type: 'download',
          });
        } else {
          TagCommanderManager.tagClick({
            chapitre_1: 'mes_compteurs',
            chapitre_2: 'mes_donnees_energetiques',
            chapitre_3: 'cockpit_services_mesures',
            page: 'telecharger_letat_de_mes_services',
            type: 'download',
          });
        }
      });
  }

  hideContent() {
    // Chargement de la popin
    document.getElementById('loader').setAttribute('style', 'visibility : visible;');
    document
      .getElementById('modal-etat-services')
      .getElementsByClassName('lnc-modal-container')
      .item(0)
      ?.setAttribute('style', 'width:535px;');
    this.toggleVisibility('erreur-technique', false);
    this.toggleVisibility('prm-content', false);
    this.toggleVisibility('cdc-content', false);
    this.toggleButtonContainer(false);
    this.toastError.hide();
    this.toastError.setAttribute('style', 'display: none;');
  }

  showError() {
    // Chargement de la popin
    document.getElementById('loader').setAttribute('style', 'display : none;');
    document
      .getElementById('modal-etat-services')
      .getElementsByClassName('lnc-modal-container')
      .item(0)
      ?.setAttribute('style', 'width:896px;');
    this.toggleVisibility('erreur-technique', true);
    this.toggleVisibility('prm-content', false);
    this.toggleVisibility('cdc-content', false);
    this.toggleButtonContainer(false);
  }

  showSuccessPrmsSynthese() {
    // Chargement de la popin
    document.getElementById('loader').setAttribute('style', 'display : none;');
    document
      .getElementById('modal-etat-services')
      .getElementsByClassName('lnc-modal-container')
      .item(0)
      ?.setAttribute('style', 'width:535px;');
    this.toggleVisibility('erreur-technique', false);
    this.toggleVisibility('prm-content', true);
    this.toggleVisibility('cdc-content', true);
    this.toggleButtonContainer(true);
  }

  toggleVisibility(id, isVisible) {
    document.getElementById(id).hidden = !isVisible;
  }

  toggleButtonContainer(isVisible) {
    document.querySelector('#modal-etat-services .button-container').hidden = !isVisible;
  }

  /**
   * Fermeture de la modal etat services avec émission d'un événement accept
   */
  hideSuccess() {
    super.hideOnAccept();
  }
}
